 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE from '@/components/Text/Titlepage'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTINTRO from '@/components/Text/Intro'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTSERIALKILLERS from '@/components/Text/SerialKillers'
 import TEXTTHEOTHERJACKS from '@/components/Text/TheOtherJacks'
 import TEXTTHEOLDWEST from '@/components/Text/TheOldWest'
 import TEXTLINCOLN from '@/components/Text/Lincoln'
 import LOVE_2 from '@/components/love_2'
 import TEXTSHORTCRIMESTORIES from '@/components/Text/ShortCrimeStories'
 import TEXTPHOTOS from '@/components/Text/Photos'
 import TEXTCTA from '@/components/Text/CTA'
 import TEXTTCC1_EXCERPTAD from '@/components/Text/TCC1_ExcerptAd'
 import TEXTTWEOSK_EXCERPTAD from '@/components/Text/TWEoSK_ExcerptAd'
 import TEXTUNDERAFULLMOON_EXCERPT_V1 from '@/components/Text/UnderAFullMoon_excerpt_v1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/Intro",
 			"name" : "Text/Intro",
 			"component" : TEXTINTRO
 		},
 		{
 			"path" : "/Text/Dedication",
 			"name" : "Text/Dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/SerialKillers",
 			"name" : "Text/SerialKillers",
 			"component" : TEXTSERIALKILLERS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js